var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "align-items-center"
  }, [_vm._v("Berikut Adalah Kode Registrasi Anda:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h2', {
    staticClass: "align-items-center",
    staticStyle: {
      "font-family": "'Verdana'"
    }
  }, [_vm._v(" " + _vm._s(_vm.kodeRegis.kd_regis) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h6', {
    staticClass: "align-items-center"
  }, [_vm._v("Silahkan tunjukan kode diatas kepada petugas Bea dan Cukai di Terminal Kedatangan Anda")])])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2e7201","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/transit/ResultTransit.vue
// module id = 396
// module chunks = 0